import { LogErrors } from './../../LogErrors'
import { DoubleAttempt } from './../Helpers/DoubleAttempt'


/**
 * Obtiene el resumen de progreso de todos los ztudiantes de un grupo para la tabla principal.
 */
const GetCourseProgressSummary = async (payload, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(payload)
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetCourseProgressSummary`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetCourseProgressSummary - DL Leaders Progress', error)
        return { success: false, message: `No ha sido posible obtener el resumen de progreso del grupo.` }
    }
}

/**
 * Obtiene el progreso de un ztudiante en un curso (desglose por bloque y resumen general).
 */
const GetCourseProgressReports = async (payload, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(payload)
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetCourseProgressReports`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetCourseProgressReports - DL Leaders Progress', error)
        return { success: false, message: `No ha sido posible obtener el detalle de progreso del estudiante.` }
    }
}

/**
 * Obtiene el listado de ztudiantes pertenecientes a un grupo específico para el perfil Líder.
 */
const GetGroupZtudiantes = async (payload, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(payload)
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetGroupZtudiantes`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetGroupZtudiantes - DL Leaders Progress', error)
        return { success: false, message: `No ha sido posible obtener el listado de Ztudiantes del grupo.` }
    }
}

export { GetCourseProgressSummary, GetCourseProgressReports, GetGroupZtudiantes };